import SidebarView from "./SidebarView";

export default SidebarView;
